<div class="page-container">
  <dbx-language-switcher [language]="$language()" (languageChange)="setLanguage($event)" />

  <div class="form-container">
    <div class="skeleton-card" style="width: auto">
      <div class="logo"></div>
      <div class="description" [innerHTML]="'registration.description' | translate"></div>
    </div>
    <form class="form" [formGroup]="form" (ngSubmit)="submit()">
      <button mat-stroked-button type="button" [routerLink]="['/' + Paths.LOGIN_PATH]">
        {{ 'registration.signIn' | translate }}
      </button>
      <div class="separator">
        <span>{{ 'registration.or' | translate }}</span>
      </div>
      <h2 class="mat-headline-2 title">{{ 'registration.title' | translate }}</h2>
      @if ($manager()) {
        <mat-form-field appearance="outline" class="field">
          <mat-label>{{ 'registration.provider' | translate }}</mat-label>
          <input matInput id="provider" name="provider" data-cy="provider-input" [value]="$manager()?.name" readonly />
        </mat-form-field>
      }
      <mat-form-field appearance="outline" class="field">
        <mat-label>{{ 'registration.company' | translate }}</mat-label>
        <input
          matInput
          id="company-name"
          name="company-name"
          data-cy="company-name-input"
          formControlName="companyName"
        />
        <mat-error>{{ 'registration.errors.companyNameRequired' | translate }}</mat-error>
      </mat-form-field>

      <div class="field-group">
        <mat-form-field appearance="outline" class="field">
          <mat-label>{{ 'registration.firstName' | translate }}</mat-label>
          <input matInput id="first-name" name="first-name" data-cy="first-name-input" formControlName="firstName" />
          <mat-error>{{ 'registration.errors.firstNameRequired' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="field">
          <mat-label>{{ 'registration.lastName' | translate }}</mat-label>
          <input matInput id="last-name" name="last-name" data-cy="last-name-input" formControlName="lastName" />
          <mat-error>{{ 'registration.errors.lastNameRequired' | translate }}</mat-error>
        </mat-form-field>
      </div>

      <div class="field-group">
        <mat-form-field appearance="outline" class="field">
          <mat-label>{{ 'registration.email' | translate }}</mat-label>
          <input matInput id="email" name="email" data-cy="email-input" type="email" formControlName="email" />
          <mat-error>
            @if (email?.hasError('required')) {
              {{ 'registration.errors.emailRequired' | translate }}
            } @else if (email?.hasError('email')) {
              {{ 'registration.errors.invalidEmail' | translate }}
            }
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="field">
          <mat-label>{{ 'registration.phone' | translate }}</mat-label>
          <input matInput id="phone" name="phone" data-cy="phone-input" type="tel" formControlName="phone" />
        </mat-form-field>
      </div>

      <div class="field-group">
        <mat-form-field appearance="outline" class="field">
          <mat-label>{{ 'registration.password' | translate }}</mat-label>
          <ul>
            <li>{{ 'resetPassword.rules.1' | translate }}</li>
            <li>{{ 'resetPassword.rules.2' | translate }}</li>
          </ul>
          <input
            matInput
            id="password"
            name="password"
            data-cy="password-input"
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
          />
          <mat-icon matSuffix (click)="togglePasswordVisibility()">
            {{ hidePassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
          <mat-error>
            @if (password?.hasError('required')) {
              {{ 'login.errors.passwordRequired' | translate }}
            } @else if (password?.hasError('minlength')) {
              {{ 'login.errors.passwordMinLength' | translate }}
            } @else if (password?.hasError('invalidPassword')) {
              {{ 'resetPassword.errors.invalidPassword' | translate }}
            }
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="field">
          <mat-label>{{ 'registration.confirmPassword' | translate }}</mat-label>
          <input
            matInput
            id="confirm"
            name="confirm"
            data-cy="confirm-input"
            [type]="hideConfirmPassword ? 'password' : 'text'"
            formControlName="confirm"
          />
          <mat-icon matSuffix (click)="toggleConfirmPasswordVisibility()">
            {{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
          <mat-error>
            @if (confirm?.hasError('required')) {
              {{ 'registration.errors.confirmPasswordRequired' | translate }}
            } @else if (confirm?.hasError('minlength')) {
              {{ 'registration.errors.passwordMinLength' | translate }}
            } @else if (confirm?.hasError('passwordMismatch')) {
              {{ 'registration.errors.passwordDoNotMatch' | translate }}
            }
          </mat-error>
        </mat-form-field>
      </div>
      <button mat-flat-button class="full-width" [disabled]="$loading()" type="submit">
        <span class="loading-button-container">
          <span [style.visibility]="$loading() ? 'hidden' : 'visible'">
            {{ 'registration.register' | translate }}
          </span>
          @if ($loading()) {
            <mat-spinner class="white" diameter="20"></mat-spinner>
          }
        </span>
      </button>
    </form>
  </div>
</div>
